import moment from "moment";
import React, { useEffect, useState } from "react";
import { CustomerContactsState } from "src/types";

import GaugeChart from "../generic/GaugePercentChart";
import { getLastWeek } from "./helpers";

interface Props {
  customerContacts: CustomerContactsState;
}

const GaugeChartContactsWithNbaLastWeek: React.FC<Props> = ({
  customerContacts,
}: Props) => {
  const [
    contactsOfferAddressedLastWeek,
    setContactsOfferAddressedLastWeek,
  ] = useState<number>();
  const [
    contactsOfferAcceptedLastWeek,
    setContactsOfferAcceptedLastWeek,
  ] = useState<number>();

  const { lastWeek, yearLastWeek, weekRangeString } = getLastWeek();

  useEffect(() => {
    const dataLastWeek = customerContacts.countPerInterval.find((interval) => {
      const d = moment(interval.date);
      return d.isoWeek() === lastWeek && d.isoWeekYear() === yearLastWeek;
    });
    if (dataLastWeek) {
      setContactsOfferAddressedLastWeek(dataLastWeek.countOfferAddressed);
      setContactsOfferAcceptedLastWeek(dataLastWeek.countOfferAccepted);
    }
  }, [customerContacts, lastWeek, yearLastWeek]);
  return (
    <GaugeChart
      value={contactsOfferAcceptedLastWeek}
      maxValue={contactsOfferAddressedLastWeek}
      title={`Vergangene Woche (${weekRangeString})`}
      labelMaxValue="Kontakte vergangene Woche, Angebot angesprochen (gesamt)"
    />
  );
};

export default GaugeChartContactsWithNbaLastWeek;



// WEBPACK FOOTER //
// ./src/components/NbaEvaluation/GaugeChartContactsOfferAcceptedIfAddressed.tsx